import { RouteConfig } from 'vue-router'

const surveyRoutes: Array<RouteConfig> = [
    {
        path: '/:event_identifier/surveys',
        alias: '/dev/:event_identifier',
        name: 'surveys.login',
        meta: {
            title: 'Login',
            layout: 'enduser',
            requireAuth: false
        },
        component: () => import('@/modules/survey/views/login/login.vue')
    }, {
        path: '/:event_identifier/surveys/loginsurveys/:login_key/:pagenum',
        alias: '/dev/:event_identifier/surveys/loginsurveys/:login_key/:pagenum',
        name: 'surveys.loginsurveys', // the previous name was a duplicate from the main router. I renamed, I don't think the former is used anywhere in the surveys views.
        meta: {
            title: 'Surveys',
            layout: 'enduser',
            requireAuth: false
        },
        component: () => import('@/modules/survey/views/index/index.vue')
    }, {
        path: '/:event_identifier/surveys/dashboard',
        alias: '/dev/:event_identifier/surveys',
        name: 'surveys.index',
        meta: {
            title: 'Surveys',
            layout: 'enduser',
            requireAuth: true
        },
        component: () => import('@/modules/survey/views/index/index.vue')
    }, {
        path: '/:event_identifier/survey/:session_uuid',
        alias: '/dev/:event_identifier/survey/:session_uuid',
        name: 'surveys.session',
        meta: {
            title: 'Session',
            layout: 'enduser',
            requireAuth: true
        },
        component: () => import('@/modules/survey/views/session/session.vue')
    }, {
        path: '/:event_identifier/survey/:session_uuid/finish',
        alias: '/dev/:event_identifier/survey/:session_uuid/finish',
        name: 'surveys.session.finish',
        meta: {
            title: 'Finish',
            layout: 'enduser',
            requireAuth: true
        },
        component: () => import('@/modules/survey/views/finish/finish.vue')
    },
]

export default surveyRoutes
